<script>

    import QuotationsService from '../$services/quotations.service'

    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import Spinner from '../$components/spinner.svelte'

    const data = {
        pickup: {
            zipcode: '54080'
        },
        delivery: {
            zipcode: ''
        },
        package: {
            width: 10,
            height: 10,
            length: 10,
            weight: 1,
            value: 0,
            content: 'validacion cobertura',
        }
    }

    let services = []
    let loading = false

    const providers = [
        'Estafeta',
        'Redpack',
        'FedEx',
        'DHL',
        'Sendex',
        'JTExpress',
        '99Minutos',
        'Paquetexpress',
    ]

    async function getQuotation() {

        services = []

        loading = true
        const resp = await QuotationsService.getQuotations(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        services = resp.data.sort((a, b) => {

            if(a.provider > b.provider)
                return 1

            if(a.provider < b.provider)
                return -1

            return 0
        })

        providers.forEach(item => {
            if(!services.find(service => service.provider === item))
                services.push({
                    provider: item,
                    service: 'NO DISPONIBLE',
                    isDeliveryHome: true,
                    isCoverageCost: false
                })
        })
    }

</script>

<div class="columns">
    <div class="column">
        <InputText on:enter={ getQuotation } bind:value={ data.delivery.zipcode } label="Código postal destino" icon="map-marker-alt" placeholder="Código postal de destino" />
        <Button on:click={ getQuotation } text="Buscar" icon="search" color="primary" fullwidth />
    </div>
    <div class="column">
        <Spinner {loading} />
        {#if !loading && services.length}
            <div class="title is-5">Servicios disponibles</div>
            <div class="table-container">
                <table class="table is-fullwidth">
                    {#each services as service}
                        <tr>
                            <td>{ service.provider }</td>
                            <td>
                                { service.service }
                                {#if !service.isDeliveryHome}
                                    <div class="tag is-danger">ES OCURRE</div>
                                {/if}
                                {#if service.isCoverageCost}
                                    <div class="tag is-danger">ZONA EXTENDIA</div>
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </table>
            </div>
        {/if}
    </div>
</div>